module.exports = __webpack_public_path__ + "img/nima_odyssey.gm.68f93ad.png";